import { render, staticRenderFns } from "./m-form-block.vue?vue&type=template&id=74eb2899&scoped=true&lang=pug"
import script from "./m-form-block.vue?vue&type=script&lang=js"
export * from "./m-form-block.vue?vue&type=script&lang=js"
import style0 from "./m-form-block.vue?vue&type=style&index=0&id=74eb2899&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eb2899",
  null
  
)

export default component.exports